import { PropTypes } from "prop-types";
import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import { useThemeContext } from "@/react/providers";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Icon } from "@circle-react-shared/Icon";
import { ManageBookmarkActions } from "./ManageBookmarkActions";

export const LinkBookmarkIcon = ({
  space,
  bookmark,
  onEditClick,
  onDeleteClick,
}) => {
  const canManageBookmark = userIsAdminOrModeratorOfSpace(space);
  const { currentAppearance } = useThemeContext();

  const LinkIcon = () => (
    <EmojiRenderer
      className="!h-5"
      emoji={bookmark.emoji}
      appearance={currentAppearance}
      customEmojiUrl={bookmark.custom_emoji_url}
      customEmojiDarkUrl={bookmark.custom_emoji_dark_url}
      emptyIcon={
        <Icon
          className="text-default group-hover:text-dark"
          type="new-tab-link"
          size={16}
        />
      }
    />
  );

  if (!canManageBookmark) {
    return (
      <span className="flex h-5 w-5">
        <LinkIcon />
      </span>
    );
  }

  return (
    <span className="flex h-5 w-5">
      <span className="flex h-5 w-5 justify-center group-hover:invisible">
        <LinkIcon />
      </span>
      <span className="invisible -ml-5 h-5 w-5 group-hover:visible">
        <ManageBookmarkActions
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          bookmark={bookmark}
        />
      </span>
    </span>
  );
};

LinkBookmarkIcon.propTypes = {
  space: PropTypes.shape({
    current_user_roles: PropTypes.array,
  }),
  bookmark: PropTypes.shape({
    url: PropTypes.string,
    emoji: PropTypes.string,
    custom_emoji_url: PropTypes.string,
    custom_emoji_dark_url: PropTypes.string,
    name: PropTypes.string,
  }),
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
